import { ComponentType } from 'react';
import * as RoutePaths from './paths';

export const routes: {
  path: string;
  component: () => Promise<{ default: ComponentType<any> }>;
  protected?: boolean;
  unauthenticate?: boolean;
}[] =
  [
    {
      path: RoutePaths.loginPath,
      component: () => import('../components/account/Login/LoginRoute'),
      protected: false,
    },
    {
      path: RoutePaths.signupPath,
      component: () => import('../components/account/Signup/SignupRoute'),
      protected: false,
    },
    {
      path: RoutePaths.verifyEmailPath,
      component: () => import('../components/account/VerifyEmail'),
    },
    {
      path: RoutePaths.requestResetPasswordPath,
      component: () => import('../components/account/RequestResetPassword'),
    },
    {
      path: RoutePaths.checkEmailPath,
      component: () => import('../components/account/CheckEmail'),
    },
    {
      path: RoutePaths.joinCompanyPath,
      component: () => import('../components/account/JoinCompany'),
      unauthenticate: true,
    },
    {
      path: RoutePaths.invalidInvitePath,
      component: () => import('../components/account/InvalidInvite'),
    },
    {
      path: RoutePaths.adminSignupPath,
      component: () => import('../components/account/Admin/Signup'),
    },
    {
      path: RoutePaths.resetSuccessPath,
      component: () => import('../components/account/ResetSuccess'),
    },
    {
      path: RoutePaths.resetPasswordPath,
      component: () => import('../components/account/ResetPassword'),
    },
    {
      path: RoutePaths.linkExpiredPath,
      component: () => import('../components/account/LinkExpired'),
    },
    {
      path: RoutePaths.linkInvalidPath,
      component: () => import('../components/account/LinkInvalid'),
    },
    {
      path: RoutePaths.moveCompanySuccessPath,
      component: () => import('../components/account/MoveCompanySuccess'),
      protected: false,
    },
  ];
